<template>
  <fragment>
    <tr>
      <td>
        <strong>Início da cobrança</strong>
      </td>
      <td class="contract-creation-rule__start-rule">
        <loading v-if="loading" full-parent size="small" />
        <select-field
          placeholder=" "
          v-model="form.get('startRule').value"
          :errors="form.get('startRule').errors"
          @input="emitFormFieldChanged('startRule')"
          :options="startRuleTypes"
        />
      </td>
    </tr>
    <tr>
      <td>
        <strong>Duração do contrato</strong>
      </td>
      <td>
        <input-field
          type="number"
          placeholder="Número de meses da duração"
          v-model.number="form.get('duration').value"
          :errors="form.get('duration').errors"
          @input="emitFormFieldChanged('duration')"
        />
      </td>
    </tr>
  </fragment>
</template>
<script>
import { InputField, SelectField } from 'components/form';
import EnumsService from 'services/EnumsService';
import Loading from 'components/Loading';

export default {
  components: {
    InputField,
    SelectField,
    Loading,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      startRuleTypes: [],
      loading: false,
    };
  },
  mounted() {
    this.loading = true;

    EnumsService.getStartRuleTypes()
      .then((startRuleTypes) => {
        this.startRuleTypes = startRuleTypes;
      })
      .catch(() => {
        this.$router.push('/');
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    emitFormFieldChanged(field) {
      this.$emit('form-field-changed', { [field]: this.form.get(field).value });
    },
  },
};
</script>
<style lang="scss" scoped>
.contract-creation-rule__start-rule {
  position: relative;
}
</style>
